// DayPasses action types

const dayPassesActionTypes = {
  SET_DAYPASSES: 'SET_DAYPASSES'
};

export default dayPassesActionTypes;
